class ShippingEstimator {

  constructor() {

    this.button =
      document.getElementById(
        'EstimateShippingBtn'
      );

    if (!this.button) return;

    this.results =
      document.getElementById(
        'ShippingResults'
      );

    this.delivery =
      document.getElementById(
        'DeliveryEstimate'
      );

    this.country =
      document.getElementById(
        'ShippingCountry'
      );
      this.province =
  document.getElementById(
    'ShippingProvince'
  );

    this.locationInput =
      document.getElementById(
        'ShippingLocation'
      );

    this.zip =
      document.getElementById(
        'ShippingZip'
      );

    this.lookup =
      document.getElementById(
        'PostcodeLookup'
      );

    this.variantInput =
      document.querySelector(
        'input[name="id"]'
      );

    this.bindEvents();

    if (
  window.google &&
  google.maps &&
  typeof google.maps.importLibrary === 'function'
) {

  this.initGooglePlaces();

}
  }

  bindEvents() {

    this.button.addEventListener(
      'click',
      () => this.calculate()
    );

    document.addEventListener(
      'variant:change',
      () => {
        this.clearResults();
      }
    );
  }

  async initGooglePlaces() {

  try {

    const { AutocompleteSuggestion } =
      await google.maps.importLibrary(
        "places"
      );

    let debounceTimer;

    let dropdown =
      document.getElementById(
        "ShippingSuggestions"
      );

    if (!dropdown) {

      dropdown =
        document.createElement("div");

      dropdown.id =
        "ShippingSuggestions";

      dropdown.className =
        "shipping-suggestions";

      this.locationInput
        .parentNode
        .appendChild(dropdown);

    }

    const clearDropdown = () => {
      dropdown.innerHTML = "";
      dropdown.style.display = "none";
    };

    const showDropdown = () => {
      dropdown.style.display = "block";
    };

    this.locationInput.addEventListener(
      "input",
      (e) => {

        clearTimeout(
          debounceTimer
        );

        const value =
          e.target.value.trim();

        this.zip.value = "";

        this.lookup.innerHTML = "";

        if (
          value.length < 1
        ) {

          clearDropdown();

          return;
        }

        debounceTimer =
          setTimeout(
            async () => {

              try {

                const { suggestions } =
                  await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                    input: value,
                    includedRegionCodes: ["au"],
                    includedPrimaryTypes: ["postal_code"]
                  });

                dropdown.innerHTML = "";

                if (
                  !suggestions ||
                  !suggestions.length
                ) {

                  clearDropdown();

                  return;
                }
                

                suggestions.forEach(
                  (
                    suggestion
                  ) => {

                    const button =
                      document.createElement(
                        "button"
                      );

                    button.type =
                      "button";

                    button.className =
                      "shipping-suggestion";

                    button.textContent =
                      suggestion.placePrediction
                        .text
                        .text;

                    button.addEventListener(
                      "click",
                      async () => {

                        try {

                          const place =
                            suggestion
                              .placePrediction
                              .toPlace();

                          await place.fetchFields({
                            fields: [
                              "addressComponents",
                              "formattedAddress"
                            ]
                          });

                          let postcode =
                            "";

                          let suburb =
                            "";

                          let state =
                            "";

                          let stateLong =
                            "";

                          (
                            place.addressComponents ||
                            []
                          ).forEach(
                            (
                              component
                            ) => {

                              const types =
                                component.types ||
                                [];

                              if (
                                types.includes(
                                  "postal_code"
                                )
                              ) {

                                postcode =
                                  component.longText;

                              }

                              if (
                                types.includes(
                                  "locality"
                                )
                              ) {

                                suburb =
                                  component.longText;

                              }

                              if (
                                types.includes(
                                  "administrative_area_level_1"
                                )
                              ) {

                                state =
                                  component.shortText;

                                stateLong =
                                  component.longText;

                              }

                            }
                          );

                          this.locationInput.value =
                            place.formattedAddress;
                          $('.delivery-to').html(place.formattedAddress);
                          this.zip.value =
                            postcode;

                          if (
                            this.province
                          ) {

                            this.province.value =
                              stateLong;

                          }

                          this.lookup.innerHTML =
                            `
                              ${suburb},
                              ${state}
                              ${postcode}
                            `;

                          clearDropdown();

                          if (
                            postcode
                          ) {

                            await this.calculate();

                          }

                        } catch (
                          error
                        ) {

                          console.error(
                            error
                          );

                        }

                      }
                    );

                    dropdown.appendChild(
                      button
                    );

                  }
                );

                showDropdown();

              } catch (
                error
              ) {

                console.error(
                  "Places API Error",
                  error
                );

              }

            },
            300
          );

      }
    );

    document.addEventListener(
      "click",
      (event) => {

        if (
          !event.target.closest(
            ".shipping-location-wrapper"
          )
        ) {

          clearDropdown();

        }

      }
    );

  } catch(error) {

    console.error(
      "Google Places init failed",
      error
    );

  }

}

  setLoading(state) {

    const spinner =
      this.button.querySelector(
        '.btn-spinner'
      );

    const text =
      this.button.querySelector(
        '.btn-text'
      );

    if (state) {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'true');

      this.button.disabled =
        true;

    } else {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'false');

      this.button.disabled =
        false;
    }
  }

  clearResults() {

    this.results.innerHTML = '';

    this.delivery.innerHTML = '';
    $('.shipping-estimator').removeClass('show-results');
  }

  async addTempItem(
    variantId
  ) {

    const response =
      await fetch(
        '/cart/add.js',
        {
          method:'POST',
          headers:{
            'Content-Type':
            'application/json'
          },
          body:JSON.stringify({
            id:variantId,
            quantity:1
          })
        }
      );

    return response.json();
  }

  async removeTempItem(
    variantId
  ) {

    const cart =
      await fetch('/cart.js')
      .then(r => r.json());

    const item =
      cart.items.find(
        item =>
          item.variant_id ==
          variantId
      );

    if (!item) return;
const newQty = item.quantity - 1;
    await fetch(
      '/cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
          'application/json'
        },
        body:JSON.stringify({
          id:item.key,
          quantity:newQty
        })
      }
    );
  }

  async fetchRates(
    country,
    province,
    zip
  ) {

    const response =
      await fetch(
        `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
      );

    return response.json();
  }

  renderRates(rates) {

    if (!rates.length) {

      this.results.innerHTML =
        'No shipping methods available';

      return;
    }

    let html = '';

    rates.forEach(rate => {

      html += `
        <div class="shipping-rate">

          <div>
            ${rate.name}
          </div>

          <div>
            $${rate.price}
          </div>

        </div>
      `;
    });

    this.results.innerHTML =
      html;
      $('.shipping-estimator').addClass('show-results');
  }

  renderDeliveryEstimate(
    rates
  ) {

    const hasExpress =
      rates.some(rate =>
        rate.name
        .toLowerCase()
        .includes('express')
      );

    this.delivery.innerHTML =
      hasExpress
      ? 'Express delivery available: 2–4 business days'
      : 'Estimated delivery: 5–7 business days';
  }

  async calculate() {

    try {

      const zip =
        this.zip.value;

      if (!zip) {
        return;
      }
      const province =
  this.province.value;

       this.setLoading(true);

      this.clearResults();

      const variantId =
        this.variantInput.value;
      document.documentElement.classList.add(
  'shipping-estimator-running'
);
window.__shippingEstimatorRunning = true;
      await this.addTempItem(
        variantId
      );
      
      const data =
        await this.fetchRates(
          'AU',
          province,
          zip
        );
        
      const rates =
        data.shipping_rates || [];

      this.renderRates(
        rates
      );

      // this.renderDeliveryEstimate(
      //   rates
      // );

      await this.removeTempItem(
        variantId
      );
window.__shippingEstimatorRunning = false;
    } catch(error) {

      console.error(error);

      this.results.innerHTML =
        'Unable to estimate shipping';

    } finally {
       this.setLoading(false);
       document.documentElement.classList.remove(
            'shipping-estimator-running'
          );
          
      
    }
  }
}

window.addEventListener(
  'load',
  () => {

    const waitForGoogle = () => {

      if (
        window.google &&
        google.maps &&
        typeof google.maps.importLibrary === 'function'
      ) {

        new ShippingEstimator();

      } else {

        setTimeout(
          waitForGoogle,
          200
        );

      }

    };

    waitForGoogle();

  }
);

(function() {

  const originalDispatch =
    document.dispatchEvent;

  document.dispatchEvent =
    function(event) {

      if (
        document.documentElement.classList.contains(
          'shipping-estimator-running'
        ) &&
        event.type === 'rebuy:cart.change'
      ) {
        console.log(
          'Blocked rebuy:cart.change'
        );
        return true;
      }

      return originalDispatch.call(
        this,
        event
      );
    };

})();